var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98193 9H2.98193V2H9.98193V1H2.98193C2.71672 1 2.46236 1.10536 2.27483 1.29289C2.08729 1.48043 1.98193 1.73478 1.98193 2V9ZM14.9819 14V5H5.98193V14H14.9819ZM5.98193 4H14.9819C15.2472 4 15.5015 4.10536 15.689 4.29289C15.8766 4.48043 15.9819 4.73478 15.9819 5V14C15.9819 14.2652 15.8766 14.5196 15.689 14.7071C15.5015 14.8946 15.2472 15 14.9819 15H5.98193C5.71672 15 5.46236 14.8946 5.27483 14.7071C5.08729 14.5196 4.98193 14.2652 4.98193 14V5C4.98193 4.73478 5.08729 4.48043 5.27483 4.29289C5.46236 4.10536 5.71672 4 5.98193 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.49d74e2540e3e0a30815be076e33f905.svg";
export { ForwardRef as ReactComponent };